import React from 'react';
import { Calendar, Clock, Users } from 'lucide-react';

interface StepIndicatorProps {
  currentStep: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep }) => {
  return (
    <div className="flex justify-between mb-8">
      <div className={`flex flex-col items-center ${currentStep >= 1 ? 'text-orcsys-500' : 'text-gray-400'}`}>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 ${currentStep >= 1 ? 'bg-orcsys-100' : 'bg-gray-100'}`}>
          <Calendar size={20} />
        </div>
        <span className="text-sm font-medium">Date</span>
      </div>
      <div className={`flex-1 border-t-2 self-start mt-5 mx-4 ${currentStep >= 2 ? 'border-orcsys-300' : 'border-gray-200'}`}></div>
      <div className={`flex flex-col items-center ${currentStep >= 2 ? 'text-orcsys-500' : 'text-gray-400'}`}>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 ${currentStep >= 2 ? 'bg-orcsys-100' : 'bg-gray-100'}`}>
          <Clock size={20} />
        </div>
        <span className="text-sm font-medium">Heure</span>
      </div>
      <div className={`flex-1 border-t-2 self-start mt-5 mx-4 ${currentStep >= 3 ? 'border-orcsys-300' : 'border-gray-200'}`}></div>
      <div className={`flex flex-col items-center ${currentStep >= 3 ? 'text-orcsys-500' : 'text-gray-400'}`}>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 ${currentStep >= 3 ? 'bg-orcsys-100' : 'bg-gray-100'}`}>
          <Users size={20} />
        </div>
        <span className="text-sm font-medium">Informations</span>
      </div>
    </div>
  );
};

export default StepIndicator; 